var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { DynamicCatalogBuilder } from '../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
import { Box, useMediaQuery } from '@mui/material';
import CardView from '../../proprietaryWarranty/pages/proprietaryCardView';
import { invoicedTabPagingTabAPICall } from '../../jobcardInvoices/services/apiCall';
import dayjs from 'dayjs';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { ReactComponent as MoreIconSvg } from '../../../assets/images/dots-vertical.svg';
import { ReactComponent as PrintIcon } from '../../../assets/images/printIcon.svg';
import { ReactComponent as ShearIcon } from '../../../assets/images/shearIcon.svg';
import { ReactComponent as ViewIcon } from '../../../assets/images/viewIcon.svg';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { useAppDispatch } from '../../../store/hooks';
import ActionMenuList from '../../../builderPackage/components/actionsMenuList';
var ReturnTab = function () {
    var _storedMenuFeatures$M;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var storedMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS === null || LOCAL_STORAGE_KEYS === void 0 ? void 0 : LOCAL_STORAGE_KEYS.SELECTED_MENU);
    var CSRMenuFeatures = storedMenuFeatures === null || storedMenuFeatures === void 0 || (_storedMenuFeatures$M = storedMenuFeatures.Menus[5]) === null || _storedMenuFeatures$M === void 0 ? void 0 : _storedMenuFeatures$M.Features;
    var dispatch = useAppDispatch();
    console.log('-----CSRMenuFeatures-----1--', CSRMenuFeatures);
    var getInvoiceIcon = function (Name) {
        switch (Name) {
            case 'ViewReturn':
                return /*#__PURE__*/ React.createElement(ViewIcon, {
                    color: "secondary.500",
                    fontWeight: "medium"
                });
            case 'ShareReturn':
                return /*#__PURE__*/ React.createElement(ShearIcon, {
                    color: "secondary.500",
                    fontWeight: "medium"
                });
            case 'PrintReturn':
                return /*#__PURE__*/ React.createElement(PrintIcon, {
                    color: "secondary.500",
                    fontWeight: "medium"
                });
            default:
                return /*#__PURE__*/ React.createElement(React.Fragment, null);
        }
    };
    var columns = [{
            field: 'ReturnNo',
            headerName: 'Return no.',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'ReturnDate',
            headerName: 'Return date',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'InvoiceNo',
            headerName: 'Invoice no',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'InvoiceDate',
            headerName: 'Invocie date.',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'ExecutiveName',
            headerName: 'Executive Name',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'InvocieCreatedBy',
            headerName: 'Invoice Created By',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'RerurnCreatedBy',
            headerName: 'Return Created by',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'InvoiceAmount',
            headerName: 'Invoice amount',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'ReturnAmount',
            headerName: 'Return amount',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'ReturnPaymentMode',
            headerName: 'Ret. payment mode',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'ReturnPaymentMethod',
            headerName: 'Ret. payment method',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'ReurnStatus',
            headerName: 'Status',
            minWidth: 150,
            editable: false,
            flex: 1
        }, {
            field: 'ReturnActions',
            headerName: 'Actions',
            minWidth: 150,
            editable: false,
            flex: 1,
            renderCell: function (params) {
                var _this = this;
                return /*#__PURE__*/ React.createElement(MoreIconSvg, {
                    color: "secondary.600",
                    onClick: function (e) { return __awaiter(_this, void 0, void 0, function () {
                        var res;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Menu',
                                        Component: ActionMenuList,
                                        containerProps: {
                                            anchorEl: e === null || e === void 0 ? void 0 : e.target,
                                            anchorOrigin: {
                                                vertical: 'center',
                                                horizontal: 'right'
                                            },
                                            transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'right'
                                            }
                                        },
                                        componentProps: {
                                            items: [{
                                                    id: 'ViewReturn',
                                                    children: [/*#__PURE__*/ React.createElement(ViewIcon, {
                                                            color: "secondary.500",
                                                            fontWeight: "medium"
                                                        }), "View Invoice"]
                                                }, {
                                                    id: 'ShareReturn',
                                                    children: [/*#__PURE__*/ React.createElement(ShearIcon, {
                                                            color: "secondary.500",
                                                            fontWeight: "medium"
                                                        }), "Share Invoice"]
                                                }, {
                                                    id: 'PrintReturn',
                                                    children: [/*#__PURE__*/ React.createElement(PrintIcon, {
                                                            color: "secondary.500",
                                                            fontWeight: "medium"
                                                        }), "Print Invoice"]
                                                }]
                                            // items: [
                                            //     CSRMenuFeatures.map((item: any) => {
                                            //         console.log(item?.DisplayName);
                                            //         return {
                                            //             id: item?.id,
                                            //             children: item.DisplayName
                                            //         }
                                            //     })
                                            // ]
                                        }
                                    }))];
                                case 1:
                                    res = _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                });
            }
        }];
    return isMobile ? /*#__PURE__*/ React.createElement(Box, {
        py: 2
    }, /*#__PURE__*/ React.createElement(CardView, {
        isReadyForInvoiceTitle: true,
        isGrandTotalButton: false,
        isMenuIcon: true,
        isExpandButton: true,
        pagingApiCall: invoicedTabPagingTabAPICall,
        pagingKey: 'abcd',
        pagingRequest: {
            OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
        },
        pageSize: 20,
        menuIcons: getInvoiceIcon,
        actionsMenu: CSRMenuFeatures,
        cardMapper: function (data) {
            var _dayjs, _data$InvoiceDate;
            return {
                id: "card-".concat(data === null || data === void 0 ? void 0 : data.id),
                docNo: data !== null && data !== void 0 && data.RegistrationNo ? data === null || data === void 0 ? void 0 : data.RegistrationNo : '-',
                title: data !== null && data !== void 0 && data.InvoiceDate ? (_dayjs = dayjs((_data$InvoiceDate = data === null || data === void 0 ? void 0 : data.InvoiceDate) !== null && _data$InvoiceDate !== void 0 ? _data$InvoiceDate : '')) === null || _dayjs === void 0 ? void 0 : _dayjs.format('DD MMM, YYYY') : '-',
                statusName: data === null || data === void 0 ? void 0 : data.JobCardStatusName,
                details: [{
                        label: "Invoice number:",
                        value: data === null || data === void 0 ? void 0 : data.InvoiceNumber
                    }, {
                        label: "Invoice date:",
                        value: data === null || data === void 0 ? void 0 : data.InvoiceDate
                    }, {
                        label: "Executive name:",
                        value: data === null || data === void 0 ? void 0 : data.ExecutiveName
                    }, {
                        label: "Invoice created by:",
                        value: data === null || data === void 0 ? void 0 : data.InvoiceCreatedBy
                    }, {
                        label: "Return created by:",
                        value: data === null || data === void 0 ? void 0 : data.ReturnCreatedBy
                    }, {
                        label: "Invoice amount:",
                        value: data === null || data === void 0 ? void 0 : data.InvoiceAmount
                    }, {
                        label: "Return amount:",
                        value: data === null || data === void 0 ? void 0 : data.ReturnAmount
                    }, {
                        label: "Ret payment mode :",
                        value: data === null || data === void 0 ? void 0 : data.ReturnPaymentMode
                    }, {
                        label: "Ret payment method :",
                        value: data === null || data === void 0 ? void 0 : data.ReturnPaymentMethod
                    }]
            };
        }
    })) : /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        columns: columns,
        dataGridProps: {
            disableColumnMenu: true,
            initialState: {
                pinnedColumns: {
                    right: ['ReturnActions']
                }
            }
        },
        rows: [{
                id: '12',
                ReturnNo: '01',
                ReturnDate: '01-02-2025',
                InvoiceNo: 'ABCD-12345678',
                InvoiceDate: '01-02-2025',
                ExecutiveName: 'BM Rushi'
            }]
    });
};
export default ReturnTab;
